export default __webpack_public_path__ + "static/media/register.a2201c7a.png";